<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SuppliersApi from "@/services/suppliers-api";
import ItemsApi from "@/services/items-api";
import OffersList from "@/router/views/promotions/offres";
import BannerApi from "@/services/banner-api";
import offersApi from "@/services/offers-api";

//import DynamicMarquee from 'vue-dynamic-marquee';

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,OffersList/*, DynamicMarquee*/, VueSlickCarousel
  },

  created() {
    this.newItems.forEach(n => {
      this.$set(n, 'currentPage', 1);
    });
  },

  data() {
    return {
      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],
      itemsStep: 4,

      currentPage: 1,
      perPage: 10,
      windowWidth: window.innerWidth,
      visibleItems: {},
      rotationCursor: {},
      intervalId: null,

      pagemodelMain: {currentPage : 1, perPage : 1, totalRows: 0},
      expiredSoonPromotion:null,
      selectedPromotion:null,
      showNewItemModal: false,
      selectedItemBySupplier:[],
      selectedNewItemSupplierName: null,

      showNowAvailableItemsModal:false,
      nowAvailableItemsList:[],
      moreOrderItems:[],

      fields: [
        { key: 'image', label: 'Image', thClass: 'text-center' },
        { key: 'title', label: 'Désignation', thClass: 'text-left' },
        { key: 'price', label: 'Prix',tdClass:"text-right",  thClass: 'text-right' },
        { key: 'discount', label: 'Remise', tdClass: 'text-center', thClass: 'text-center' },
      ],

      nowAvailableItemsFields: [
        { key: 'supplierLogo', label: '', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'title', label: 'Désignation', thClass: 'text-left' },
        { key: 'image', label: 'Image', thClass: 'text-center' },
        { key: 'price', label: 'Prix',tdClass:"text-right",  thClass: 'text-right' },
        { key: 'discount', label: 'Remise', tdClass: 'text-center', thClass: 'text-center' },
      ],


      settings: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "edgeFriction": 0.35,
          "infinite": true,
          "speed": 1000,
          "autoplay": true,
          "slidesToShow": 1,
          "slidesToScroll": 1,

          "fade": true,
          "arrows": false,

          //"vertical": true,
          //"verticalSwiping": true
        },


        settingsNewSuppliersBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 5000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 5,
        },

    };
  },

  mounted() {
    this.findBanner();

    this.findNowAvailableItems();
    this.getNewItems();
    this.getNewSuppliers();
    this.findPromotionActiveExpiredSoon()
    this.findMoreOrderItems();
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.intervalId);
  },


computed: {

    maxVisible() {
      const w = this.windowWidth

      if (w < 576) return 1        // sm
      if (w < 768) return 2        // md
      if (w < 1200) return 3        // lg
      return 4                    // xl
    },

    totalRows() {
      return this.selectedItemBySupplier.length
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.selectedItemBySupplier.slice(start, end)
    },


},

  methods: {

    onResize() {
      this.windowWidth = window.innerWidth
      this.doNewItemsPagination()
    },

    startRotation() {
      this.doNewItemsPagination()
      this.intervalId = setInterval(() => {
        this.doNewItemsPagination()
      }, 3000)
    },

    fitsVisible(items) {
      return items.length <= this.maxVisible
    },

    doNewItemsPagination(){
        this.newItems.forEach(newItem => {
        const supplierId = newItem.supplier.id
        const items = newItem.items

        if (!items || !items.length) return

        if (items.length <= this.maxVisible) {
          this.$set(this.visibleItems, supplierId, items)
          return
        }

        if (!this.visibleItems[supplierId]) {
          this.$set(this.visibleItems, supplierId, items.slice(0, this.maxVisible))
          this.$set(this.rotationCursor, supplierId, this.maxVisible)
          return
        }

        const cursor = this.rotationCursor[supplierId] % items.length
        const nextItem = items[cursor]

        this.visibleItems[supplierId] = [
          nextItem,
          ...this.visibleItems[supplierId]
        ].slice(0, this.maxVisible)

        this.rotationCursor[supplierId]++
      })
    },

    openNowAvailableItemsModal() {
      this.showNowAvailableItemsModal = true

      this.nowAvailableItemsList = this.nowAvailableItems.map(entry => {
        return {
          ...entry.item,
          supplierLogo: entry.supplier.logo
        }
      })
    },

    closePromotionModal(){
      this.selectedPromotion = null
    },

    openPromotion(promotion){
      this.selectedPromotion = promotion
    },

    previousPromotion(){
      this.pagemodelMain.currentPage--;
      this.findPromotionActiveExpiredSoon()
    },

    nextPromotion(){
      this.pagemodelMain.currentPage++;
      this.findPromotionActiveExpiredSoon()
    },

    findPromotionActiveExpiredSoon(){
      offersApi.findPromotionActiveExpiredSoon(this.pagemodelMain.currentPage, this.pagemodelMain.perPage).then((result) =>{
        if(result){
          this.expiredSoonPromotion = result.list[0];
          this.pagemodelMain.totalRows = result.total;
          this.pagemodelMain.currentPage = result.page;
          this.pagemodelMain.perPage = result.pageSize;
          this.pagemodelMain.pageSize = result.pageSize;
        }
      })
    },

     openNewItemModal(newItem) {
      this.currentPage= 1,
      this.perPage= 10,
      this.showNewItemModal=true
      this.selectedItemBySupplier = newItem.items
      this.selectedNewItemSupplierName = newItem.supplier.name
    },

    loadMore(newItem) {
      newItem.visibleCount += this.itemsStep;
    },

    findBanner() {
      this.isBannerTableBusy = true;
      BannerApi.getBanners().then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    getNewSuppliers(){
      SuppliersApi.getAllNewSuppliers().then(
        response => {
          this.newSuppliers = response;
        }
      )
    },

    getNewItems(){
      ItemsApi.findNewItems().then(
        response => {
          this.newItems = response;
              this.startRotation();
        }
      )
    },

    findNowAvailableItems(){
      ItemsApi.findNowAvailableItems().then(
        response => {
          
          this.nowAvailableItems = response;
        }
      )
    },

    findMoreOrderItems(){
      ItemsApi.findMoreOrderItems().then(
        response => {
          this.moreOrderItems = response;
        }
      )
    },
    


  }
};
</script>

<template>
  <Layout>
  


    <!-- <div class="row pt-4">
        <div class="col-12">
          <h5 class="text-danger">ARTICLES A NOUVEAU DISPONIBLES</h5>
        </div>
    </div> -->
    <!-- <div class="row mt-4" style="border-radius:5px 0px 0px 5px; border:1px solid #ddd">

      <div class="col-lg-2 col-md-3 col-sm-0 text-center bg-primary " style="border-radius:5px 0px 0px 5px;  background: #2a3042;">
          <h5 class="text-white text-uppercase text-center" style="margin:auto; line-height: 60px;">Articles A NOUVEAU DISPONIBLES</h5>
        </div>

        <div class="col-lg-10 col-md-9 col-sm-12 col-xs-12 bg-white" style="height:60px; border-top:1px solid #cccfd4 ;border-bottom:1px solid #cccfd4;">
            <DynamicMarquee direction="row"  :speed="{type: 'pps',number: 60}" reverse>

              <ul v-if="newSuppliers && newSuppliers.length" style="display:flex;  list-style:none;">

                  <li v-for="supplier in newSuppliers" :key="supplier.id" style="display: inline; ">

                      <div>
                          <span class="child">
                            <img v-if="supplier.logo" v-bind:src="'/api/image/get/' + supplier.logo" alt class="avatar-sm"   
                                style="height: 60px;width: 7rem; padding:2px 4px 4px 2px;margin-right:30px;  border-left:1px solid #ddd; border-right:1px solid #ddd;" />
                              {{supplier.name}} 
                          </span>
                        </div>
                    
                  </li>
              </ul>     
            </DynamicMarquee>
        </div>
    </div> -->



    <div class="row default-banner" style="border: 1px solid #ddd;border-radius: 6px;">
      <div class="col-xl-12">
        <div class="p-0" style="/*box-shadow: 0px 1px 5px 2px #5cb45b7a*/ ">
            <b-carousel
                style="/*text-shadow: 0px 0px 2px #000; */"
                img-width="5206"
                img-height="1256"
                :interval="8000"
                indicators
                controls
              >
                <b-carousel-slide  caption="Restez à l'écoute!" img-blank img-alt="Blank Image " v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <p class="text-primary">
                    Les publicitées seront disponibles prochainement
                  </p>
                </b-carousel-slide> 

                <div v-for="banner in bannerList" :key="banner.id" >
                <b-carousel-slide v-if="!isBannerTableBusy"
                  :img-src="'/api/banner/get/' + banner.generatedName"
                ></b-carousel-slide>
              </div>
            </b-carousel>
        </div>
      </div>
    </div>

    <div class="row pt-4" v-if="expiredSoonPromotion">

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mr-2" style="background: rgb(255,255,255);
              border-radius:5px;">
        <div class="d-flex justify-content-between align-items-center pl-3 pr-3 pt-3 mb-2">
          <h4 class="mb-0 text-primary">Les offres expirant bientôt</h4>
          <span class="text-muted" style="cursor:pointer;">
            <img
              :style="{ opacity: pagemodelMain.currentPage > 1 ? 1 : 0, pointerEvents: pagemodelMain.currentPage > 1 ? 'auto' : 'none' }"
              src="@/assets/images/arrow-left.svg"
              alt="Previous"
              height="20"
              @click="previousPromotion()"
              class="hover-scale mr-2"
            />
            <img
              :style="{ opacity: pagemodelMain.currentPage < pagemodelMain.totalRows ? 1 : 0, pointerEvents: pagemodelMain.currentPage < pagemodelMain.totalRows ? 'auto' : 'none' }"
              src="@/assets/images/arrow-right.svg"
              alt="Next"
              height="20"
              @click="nextPromotion()"
              class="hover-scale ml-2"
            />
          </span>

        </div>

        <div class="d-flex pl-3 pr-3 pt-3 align-items-center">
          <img 
            class="d-none d-sm-inline mr-3 offer-logo" 
            :src="'/api/image/get/' + expiredSoonPromotion.logo" 
            alt="Logo"
          >
          <div class="media-body">
            <h2 class="font-size-16 font-weight-bold mb-2">
              <a href="javascript:void(0);" class="text-dark hover-underline"  @click="openPromotion(expiredSoonPromotion)">{{ expiredSoonPromotion.title }}</a>
            </h2>
            <p v-if="expiredSoonPromotion.formattedendDate" class="text-muted mb-1">
              Du <span class="text-success font-weight-bold">{{ expiredSoonPromotion.formattedstartDate }}</span> 
              au <span class="text-danger font-weight-bold">{{ expiredSoonPromotion.formattedendDate }}</span>, 
              Offre publiée le {{ expiredSoonPromotion.formattedPublishDate }}
            </p>
            <p v-else class="text-muted mb-1">
              A partir du <span class="text-success font-weight-bold">{{ expiredSoonPromotion.formattedstartDate }}</span>, 
              Offre publiée le {{ expiredSoonPromotion.formattedPublishDate }}
            </p>
          </div>
          <div class="ml-auto d-none d-md-inline">
            <b-button variant="success" class="rounded-pill font-weight-bold px-4 py-2 shadow-sm text-uppercase" @click="openPromotion(expiredSoonPromotion)">
              Voir l'offre
            </b-button>
          </div>
        </div>
      </div>
    </div>



    <!-- New supplier -->
    <div class="row pt-4 pb-4" v-if="newSuppliers && newSuppliers.length">
      <div class="col-lg-1" />
      <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 mr-2" style="background: rgb(255,255,255);
        /*background: linear-gradient(9deg, rgb(255, 255, 255) 67%, rgb(92, 180, 91) 70%, rgb(42, 48, 66) 76%);*/border: 2px solid #ddd; border-radius:5px; box-shadow: 0px 1px 5px 2px #ddd">
        <VueSlickCarousel v-if="newSuppliers && newSuppliers.length" v-bind="settings" >

            <div  v-for="supplier in newSuppliers" :key="supplier.id" >

                  <div class="row m-2">

                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 pt-md-0 pt-sm-4 pt-4 text-center" :style="{margin:'auto'}" >
                          <img  v-bind:src="supplier.logo ? '/api/image/get/' + supplier.logo : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"  :style="{height: '6rem', width:'11rem', margin:'auto'}"  />
                        </div>

                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-md-0  pt-sm-4 pt-4 text-center my-auto" style="vertical-align: middle;">
                          <h2 class="font-size-24 my-auto text-uppercase ">Le <strong class="text-dark">nouveau</strong> frounisseur <br class="d-md-none"/> <strong class="text-success">{{supplier.name}} </strong> </h2>
                          <span class="font-size-24 text-success pr-md-0 pl-md-0 pr-1 pl-1">VIENT DE NOUS REJOINDRE</span>                              
                        </div>

                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 pt-md-0 pt-sm-4 pt-4  text-right" :style="{margin:'auto'}" >
                          <img src="@/assets/images/logo-dark.png" alt class="img-fluid" :style="{height: '4rem', margin:'auto'}" />  
                        </div>
                  </div>
            </div>
        </VueSlickCarousel>
      </div>
    </div>  


    <OffersList class="mt-4" :isHomePage=true :selectedPromotionParam="selectedPromotion" @closeModal="closePromotionModal" />


    <!--More Order Items-->
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3"   v-if="moreOrderItems && moreOrderItems.length">

        <div class="row my-2 mb-5 py-0" style="border-radius:5px; background-color:#eaf0f7; border:1px solid #dae8f6;" >

          <div class="text-left font-size-22 font-weight-bold text-dark my-3 ml-4">  
             <h2 class="card-titl text-dark text-uppercase" style="font-size:20px; margin: 0;">
                  Produits les plus commandés durant cette semaine
            </h2>

          </div>
          

              <div class="col-12 text-left " style="vertical-align: middle;">
                <div class="row product-grid">

                  <div
                    v-for="item in moreOrderItems"
                    :key="item.id"
                    class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-4"
                  >
                    <div class="product-card-bestsellers mx-md-4 mx-2 h-100">
                      <div class="image-wrapper">
                        <img
                          :src="'/api/image/get/' + item.image"
                          alt=""
                        />
                      </div>

                      <div class="px-3 py-2">
                        
                        <h6 class="product-title mb-3 text-primary">{{ item.title }}</h6>
                        
                        <!--span class="text-secondary">{{ item.ref }}</span-->
                        <h6 class="product-title text-success">{{ item.supplierName }}</h6>


                        <div class="price-row mt-4">
                          <span class="price">{{ item.price }} TND</span>
                          <!--span v-if="item.discount" class="discount text-success">
                            {{ item.discount }}%
                          </span-->
                        </div>

                        <!--div
                          class="stock"
                          :class="item.isAvailable && item.isAvailable === 1 ? 'text-success' : 'text-danger' "
                        >
                          {{ item.isAvailable ? 'En stock' : 'Rupture de stock' }}
                        </div-->

                      </div>

                    </div>
                  </div>
                </div>
              </div>
              

        </div>
      </div>






    <!-- Item Is Now Available -->
    <div class="row mt-4 pb-4" v-if="nowAvailableItems && nowAvailableItems.length">
      <div class="col-lg-1" />
      <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12" 
            style="border: 2px solid #ddd; border-radius:5px; background-color: white;" >
          <VueSlickCarousel v-if="nowAvailableItems && nowAvailableItems.length" v-bind="settings" >

              <div  v-for="(item, index) in nowAvailableItems" :key="item.id" >

                    <div class="row clickable-row" @click="openNowAvailableItemsModal">

                    <!-- <div class="col-1"/> -->

                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-md-0 pt-sm-4 pt-4  text-center " :style="{margin:'auto'}" >
                      <img    v-bind:src="item.supplier.logo ? '/api/image/get/' + item.supplier.logo  : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"   :style="{height: '6rem', width:'11rem', margin:'auto'}"  />
                    </div>
                    
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pt-md-0 pt-sm-4 pt-4 text-center my-auto" style="vertical-align: middle;">
                      <h2 class="font-size-24  text-center my-auto" :class="index%2==0 ? 'text-primary' : 'text-primary'">{{item.item.title}} </h2>
                      <span class="font-size-24 text-success font-weight-bold pr-md-0 pl-md-0 pr-1 pl-1" >EST A NOUVEAU DISPONIBLE</span><br/>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-md-0 pt-sm-2 pt-2 text-center" >
                      <img v-bind:src="item.item.image ? '/api/image/get/' + item.item.image  : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='" :style="{height: '200px', width:'200px', 'border-radius':'10px', margin:'auto'}"  />
                    </div>
                          

                    </div>


              </div>
          </VueSlickCarousel>
      </div>
    </div>

    <!-- news and announcements -->
    <div class="row mt-4" v-if="newItems && newItems.length" >
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"   v-if="newItems && newItems.length">
        <div  v-for="newItem in newItems" :key="newItem.supplier.id" >
          <div class="bg-light row my-2 mb-5 py-0 border border-info" style="border-radius:5px;" >

            

                <!--div class="col-6 text-left my-auto pl-2 pr-2 pt-3" >
                  <h4 class="text-dark font-weight-bold text-uppercase p-1 px-4">
                    Nouveautés</h4>
                </div-->

                <div class="col-12">
                  <div class="row">
                    <div class="col-md-8 col-12 text-left my-auto pr-2 pb-0 pt-3 px-4">
                      <img
                        :src="newItem.supplier.logo 
                          ? `/api/image/get/${newItem.supplier.logo}` 
                          : placeholderImage"
                        :style="{ maxWidth: '200px', height: 'auto', margin: 'auto', borderRadius:'10px' }"
                        alt="Logo fournisseur"
                      />
                    </div>

                  <div
                    class="col-md-4 col-12 d-flex align-items-center justify-content-end py-2"
                  >
                    <div
                      class="px-4 text-primary mt-md-0 mt-2"
                      style="cursor: pointer;"
                      @click="openNewItemModal(newItem)"
                    >
                      Afficher toutes les <strong>nouveautés</strong> 
                      <img
                        src="@/assets/images/arrow-right.svg"
                        alt="Suivant"
                        height="12"
                        class="hover-scale ml-2"
                      />
                    </div>
                  </div>

                  </div>
                </div>
                
            <transition-group
              name="fancy"
              tag="div"
              class="row product-grid w-100"
              :class=" fitsVisible(newItem.items) ? '' : 'product-grid-reverse' "
            >

              <div
                v-for="item in visibleItems[newItem.supplier.id]"
                :key="item.id"
                class="col-xl-3 col-md-4 col-sm-6 col-12 mb-4"
              >

                <div class="product-card mx-md-4 mx-2 h-100">
                  <div class="image-wrapper">
                    <img :src="'/api/image/get/' + item.image" alt="" />
                  </div>

                  <div class="px-3 py-2">
                    <h6 class="product-title">{{ item.title }}</h6>

                    <div class="price-row mt-4">
                      <span class="price">{{ item.price }} TND</span>
                    </div>

                    <div
                      class="stock"
                      :class="item.isAvailable === 1 ? 'text-success' : 'text-danger'"
                    >
                      {{ item.isAvailable === 1 ? 'En stock' : 'Rupture de stock' }}
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>


          </div>
        </div>
      </div>

    <b-modal v-model="showNewItemModal" 
        hide-header 
        hide-footer 
        centered 
        size="lg"
        header-close-variant="danger">

        <div class="text-primary font-size-16 text-uppercase mb-3">
          Les nouveautés {{ selectedNewItemSupplierName == null ? "" : selectedNewItemSupplierName }}
        </div>
      
        <b-table style="max-height: 50em;"
            :striped="true"
            :small="true"
            :hover="true"
            :items="pagedItems"
            :fields="fields"
            sortKey="itemTitle"
            responsive
          >

          <template v-slot:cell(image)="{value}">
                <img v-if="value" v-bind:src="'/api/image/get/' + value"  alt height="40" style="cursor: pointer;" />
          </template>


          <template v-slot:cell(title)="{item,value}">
            <div> {{ value }}</div>
            <div> <small>Ref: {{ item.ref }}</small> </div>
          </template>

          <template v-slot:cell(discount)="{value}">
            <div> {{ value }} %</div>
          </template>

        </b-table>

                <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select   v-model="perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
       
    </b-modal>

    <b-modal v-model="showNowAvailableItemsModal" 
      hide-header 
      hide-footer 
      centered 
      size="lg"
      header-close-variant="danger">

      <div class="text-primary font-size-16 text-uppercase mb-3">
        Produits à nouveau disponibles 
      </div>
    
      <b-table style="max-height: 50em;"
          :striped="true"
          :small="true"
          :hover="true"
          :items="nowAvailableItemsList"
          :fields="nowAvailableItemsFields"
          sortKey="itemTitle"
          responsive
        >

        <template v-slot:cell(image)="{value}">
          <img v-if="value" v-bind:src="'/api/image/get/' + value"  alt height="40" style="cursor: pointer;" />
        </template>

        <template v-slot:cell(supplierLogo)="{value}">
          <img v-if="value" v-bind:src="'/api/image/get/' + value"  alt height="40" style="cursor: pointer; max-width: 100px;" />
        </template>


        <template v-slot:cell(title)="{item,value}">
          <div> {{ value }}</div>
          <div> <small>Ref: {{ item.ref }}</small> </div>
        </template>
        
        <template v-slot:cell(discount)="{value}">
          <div> {{ value }} %</div>
        </template>
        

      </b-table>

    </b-modal>


    </div> 



  </Layout>
</template>





<style>

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}


.child{
    font-family: 'Lato', sans-serif;
    font-size:14px;
    font-weight:bold;
  width:350px;
  height:60px;
  line-height:60px;
  display:inline-block;
  vertical-align:middle;
  
}

/* .clipart{
    vertical-align:middle;
    display:inline-block;
    clear:left;
} */



/* .shop-sale-banner {
  position: relative;
  margin: auto;
  width: 50%;
  text-align: center;
  color: #fff;
  height: 2em;
  line-height: 2em;
}
.shop-sale-banner:before{
  content:"";
  position: absolute;
  top: 0;
  z-index: -1;
  left: 0;
  right: 0;
  border-style: solid;
  border-width: 1em 0.4em 1em 0.4em;
  border-color: #00509D transparent #00509D transparent;
  height: 0;
} */


.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}



.newitems .simplebar-scrollbar::before {
  background-color: #297a54
}


.custom-popup-class {
    width: 60%; 
    max-width: 600px;
}

.custom-title-class {
    font-size: 24px; 
}

.custom-cancel-button-class,
.custom-confirm-button-class {
    font-size: 18px; 
}


</style>


<style scoped>




.default-banner {
  position: relative;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
}

@media (min-width: 1389px) {
  .default-banner {
    width: 100vw;
  }
}


/* product card style */

.product-grid {
  margin-top: 20px;
  position: relative;
  min-height: 400px;
}

.product-grid-reverse{
    flex-direction: row-reverse;
}

.product-card {
  background: #fff;
  border-radius: 8px;
  padding:20px;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
  margin-bottom: 20px;
  border: 1px solid #ddd;
}

.product-card-bestsellers {
  background: #fff;
  border-radius: 8px;
  padding:20px;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
  margin-bottom: 20px;
  border: 1px solid #fff;
}

.product-card:hover {
  transform: translateY(-5px);
}

.image-wrapper {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.image-wrapper img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.product-title {
  font-size: 15px;
  margin-bottom: 8px;
}

.price-row {
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.price {
  font-size: 16px;
  font-weight: 700;
}

.discount {
  font-weight: 600;
  font-size: 14px;
}

.stock {
  font-size: 14px;
  font-weight: 600;
}




</style>



<!-- Expiring soon promotion -->

<style scoped>
.offers-expiring-soon {
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 1) 60% 
  );

}

@media (max-width: 576px) {
  .offers-expiring-soon {
    max-width: 95%;
    padding: 15px;
  }
}


.offers-wrapper {
  display: flex;
  gap: 18px;
  overflow-x: auto;
  padding: 10px 0;
  align-items: stretch;
  scroll-behavior: smooth;
}




</style>



<style scoped>
.offer-logo {
  width: 60px;
  height: auto;
  margin-bottom: 0px;
}

.hover-scale {
  transition: transform 0.2s ease;
}

.hover-scale:hover {
  transform: scale(1.2);
}

.hover-underline:hover {
  text-decoration: underline;
}

.card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.clickable-row,
.clickable-row * {
  cursor: pointer;
}



/* ENTER */
.fancy-enter-active {
  transition:
    opacity 1.8s cubic-bezier(0.22, 1, 0.36, 1),
    filter 1.8s cubic-bezier(0.22, 1, 0.36, 1);
}

/* LEAVE — opacity only */
.fancy-leave-active {
  transition: opacity 0.8s ease;
  position: absolute;
}

/* ENTER FROM */
.fancy-enter {
  opacity: 0;
  filter: blur(2px);
}

/* LEAVE TO */
.fancy-leave-to {
  opacity: 0;
}

/* MOVE animation (keep smooth reflow) */
.fancy-move {
  transition: transform 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}



</style>